module.exports = __webpack_public_path__ + "static/img/10.c8ac650.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/sp/10.png
// module id = MnEG
// module chunks = 0